import { useMemo, useState } from 'react';
import _ from 'lodash';
import SelectTile from '../webapp/core/SelectTile';
import Backdrop from './Backdrop';
import { randomBetween } from '../../utils/utils';

const PhotoBackgroundRemovalDemo = ({ backgrounds = [] }) => {
  const extendedBackgrounds = useMemo(() => {
    const mapped = backgrounds.map((background) => {
      const extension = _.last(background.background[0].split('.'));
      const isVideo = ['mp4', 'mov', 'm4v'].includes(extension);

      return { background: [background.background[0]], isVideo };
    });

    return _.take(mapped, 3);
  }, [JSON.stringify(backgrounds)]);

  const modelUrl = useMemo(() => {
    const modelIdx = randomBetween(0, 3);
    const puctureIdx = randomBetween(0, 3);
    return `/static/model/${modelIdx}/${puctureIdx}.png`;
  }, []);

  const [currentBackground, setCurrentBackground] = useState(extendedBackgrounds[0]);

  const handleBackgroundChange = (selectedBackground) => {
    if (selectedBackground) {
      const background = extendedBackgrounds.find((background) => background.background[0] === selectedBackground.id);
      setCurrentBackground(background);
    }
  };

  return (
    <div className="face-effect-demo">
      <div className="video-demo face-effect-demo__capture">
        <Backdrop backdrop={currentBackground.background[0]} animated={false} />
        <img className="video-demo__photo" src={modelUrl} alt="" />
      </div>
      {extendedBackgrounds.length > 1 && (
        <div className="face-effect-demo__controls">
          {extendedBackgrounds.map((background) => (
            <SelectTile
              key={background.background[0]}
              id={background.background[0]}
              name="background"
              type="radio"
              labelHidden={true}
              autoHeight={true}
              onChange={handleBackgroundChange}
              selected={currentBackground.background[0] === background.background[0]}
            >
              {background.isVideo ? <video src={background.background[0]} /> : <img src={background.background[0]} />}
            </SelectTile>
          ))}
        </div>
      )}
    </div>
  );
};

export default PhotoBackgroundRemovalDemo;
